// src/stores/locale.js
import { defineStore } from 'pinia'
import languagesLocales from '@/i18n/languages-i18n.js'

export const useLocaleStore = defineStore('locale', {
  state: () => ({
    locale: 'en',
  }),
  getters: {
    direction: (state) => {
      return languagesLocales.filter(item => item.i18nCode === state.locale)[0]?.direction || 'ltr';
    }
  },
  actions: {
    setLocale(locale) {
      this.locale = locale
    },
  },
})
